import { mdiFileCogOutline } from '@mdi/js'
import Icon from '@mdi/react'
import { PrimitiveAtom, useAtom } from 'jotai'
import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import DoneOutlineIcon from '@/components/assets/DoneOutlineIcon'
import NotInterestedIcon from '@/components/assets/NotInterestedIcon'
import { AccordionItem, AccordionItemTrigger, AccordionRoot } from '@/components/ui/accordion'
import { Box } from '@/components/ui/box'
import { Flex } from '@/components/ui/flex'
import { Link } from '@/components/ui/link'
import { HStack } from '@/components/ui/stack'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'
import ActionButtons from '@/pages/components/conversationList/components/actionButtons'
import { chatSettingsAtom } from '@/store/gigiChat/ChatAtom'
import { IConversationSettings } from '@/types/gigiChat/ConversationSettings'

const UploadHeader = () => {
    const { t } = useTranslation()
    const [isOpen, setIsOpen] = useState(false)
    const [chatSettings] = useAtom<PrimitiveAtom<IConversationSettings | null>>(chatSettingsAtom)

    return (
        <Box>
            <Flex mb="16px" justifyContent="space-between">
                <HStack alignItems="flex-start">
                    <Icon
                        path={mdiFileCogOutline}
                        size={1}
                        style={{ marginTop: '6px' }}
                        color={useColorModeValue('var(--chakra-colors-dark-700)', 'var(--chakra-colors-white)')}
                    />
                    <Text
                        ml="8px"
                        fontSize="21px"
                        fontFamily="GSKPrecision-Bold"
                        fontWeight="bold"
                        letterSpacing="0.25px"
                        lineHeight="36px"
                        as="span"
                    >
                        {t('documents.uploadHeaderTitle')}
                    </Text>
                </HStack>
                <ActionButtons processingStrategy="DocAnalysis" />
            </Flex>
            {chatSettings && (
                <AccordionRoot multiple>
                    <AccordionItem border="none" value={'documents.disclaimers.collapsedTitle1'}>
                        <AccordionItemTrigger
                            onClick={() => {
                                setIsOpen(!isOpen)
                            }}
                            _hover={{
                                background: 'transparent',
                            }}
                            alignItems="flex-start"
                            p="0"
                        >
                            <Box flex="1" textAlign="left" display="flex" hidden={isOpen}>
                                <NotInterestedIcon
                                    color="var(--chakra-colors-gray-800)"
                                    style={{ width: '13px', height: '18px', marginRight: '8px' }}
                                />
                                <Text fontSize="12px" fontFamily="GSKPrecision-Bold" letterSpacing="0.5px">
                                    {t('global.csi.descriptions.docAnalysis.onDocumentUpload.short')}
                                </Text>
                            </Box>
                            <Box textAlign="left" hidden={!isOpen}>
                                <Box textAlign="left" hidden={!isOpen} mt="-8px">
                                    <Trans
                                        i18nKey={'global.csi.descriptions.docAnalysis.onDocumentUpload.long'}
                                        components={{
                                            bold: <b />,
                                            br: <br />,
                                            text: <Text fontSize="12px" letterSpacing="0.5px" lineHeight="18px" />,
                                            flex: <Flex mt="12px" fontSize="12px" />,
                                            noIcon: (
                                                <NotInterestedIcon
                                                    color="var(--chakra-colors-status-error)"
                                                    style={{ width: '13px', height: '18px', marginRight: '8px' }}
                                                />
                                            ),
                                            yesIcon: (
                                                <DoneOutlineIcon
                                                    color="var(--chakra-colors-status-success)"
                                                    style={{ width: '13px', height: '18px', marginRight: '8px' }}
                                                />
                                            ),
                                            link1: (
                                                <Link
                                                    href="https://myconnect.gsk.com/sites/modern-InfoProtect#/sitepages/GSK-4-CATEGORIES-OF-INFORMATION.aspx"
                                                    key="https://myconnect.gsk.com/sites/modern-InfoProtect#/sitepages/GSK-4-CATEGORIES-OF-INFORMATION.aspx"
                                                    textDecoration="underline"
                                                    isExternal
                                                />
                                            ),
                                            link2: (
                                                <Link
                                                    href="https://myconnect.gsk.com/sites/modern-privacy#/sitepages/CLASSIFICATION-VS-CATEGORISATION.aspx"
                                                    isExternal
                                                    key="https://myconnect.gsk.com/sites/modern-privacy#/sitepages/CLASSIFICATION-VS-CATEGORISATION.aspx"
                                                    textDecoration="underline"
                                                />
                                            ),
                                        }}
                                    />
                                </Box>
                            </Box>
                        </AccordionItemTrigger>
                    </AccordionItem>
                </AccordionRoot>
            )}
        </Box>
    )
}

export default UploadHeader
